
/* Live Seven Heavens basket counter */
(function () {
  function setCartCount(count) {
    const value = Number(count) || 0;
    document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble').forEach(function (el) {
      el.textContent = value;
      el.hidden = value === 0;
      el.classList.toggle('hidden', value === 0);
    });

    const link = document.querySelector('[data-cart-link]');
    if (link) {
      link.setAttribute('aria-label', value ? 'Basket, ' + value + ' ' + (value === 1 ? 'item' : 'items') : 'Basket, empty');
      link.classList.remove('sh-cart-updated');
      void link.offsetWidth;
      if (value > 0) link.classList.add('sh-cart-updated');
    }
  }

  async function refreshCartCount() {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js', {
        headers: { 'Accept': 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) return;
      const cart = await response.json();
      setCartCount(cart.item_count);
    } catch (e) {}
  }

  window.SevenHeavensCart = {
    setCount: setCartCount,
    refresh: refreshCartCount
  };

  document.addEventListener('sevenheavens:cart-updated', function (event) {
    if (event.detail && typeof event.detail.item_count !== 'undefined') {
      setCartCount(event.detail.item_count);
    } else {
      refreshCartCount();
    }
  });

  // Keep the header accurate when returning to the page via browser history.
  window.addEventListener('pageshow', refreshCartCount);
})();
// Mobile menu
const burger = document.querySelector('.sh-burger');
if (burger) {
  burger.addEventListener('click', () => {
    const l = document.querySelector('.nav-links');
    const open = l.style.display === 'flex';
    l.style.display = open ? '' : 'flex';
    if (!open) Object.assign(l.style, {
      position:'absolute', top:'100%', left:'0', right:'0',
      flexDirection:'column', background:'var(--bg)',
      padding:'1.3rem var(--pad)', borderBottom:'1px solid var(--line)', gap:'1.1rem'
    });
  });
}

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="/#"]').forEach(a => {
  a.addEventListener('click', e => {
    const id = a.getAttribute('href').slice(2);
    const target = document.getElementById(id);
    if (target && window.location.pathname === '/') {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// Build-a-Box logic
const PRICES = { 6: 24, 12: 45, 24: 84 };
const BOX_TITLES = { 6: 'Box of 6', 12: 'Box of 12', 24: 'Box of 24' };
const FLAVOURS = ['classic', 'white', 'smores', 'triple', 'pistachio', 'cinnamon', 'reverse'];
const NAMES = {
  classic: 'Classic Chocolate Chunk',
  white: 'White Chocolate Chunk',
  smores: 'S’Mores Cookie',
  triple: 'Triple Chocolate Chunk',
  pistachio: 'Pistachio Matcha Made In Heaven',
  cinnamon: 'Cinnamon Snickerdoodle',
  reverse: 'Reverse Cookies & Cream'
};

let capacity = 12;
let counts = {};
FLAVOURS.forEach(f => counts[f] = 0);

const total = () => FLAVOURS.reduce((sum, flavour) => sum + counts[flavour], 0);

function getBoxProductId(size) {
  const builder = document.getElementById('build-a-box');
  if (!builder) return '';
  return builder.dataset['boxVariant' + size] || '';
}

function getBoxProductHandle(size) {
  const builder = document.getElementById('build-a-box');
  if (!builder) return '';
  return builder.dataset['boxHandle' + size] || '';
}

const boxVariantCache = {};

async function productFromHandle(handle) {
  if (!handle) return null;
  try {
    const response = await fetch(window.Shopify.routes.root + 'products/' + encodeURIComponent(handle) + '.js', {
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) return null;
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function findProductByExactTitle(title) {
  const root = window.Shopify.routes.root || '/';
  const url = root + 'search/suggest.json?q=' + encodeURIComponent(title) +
    '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';

  try {
    const response = await fetch(url, {
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) return null;

    const data = await response.json();
    const products = data.resources && data.resources.results && data.resources.results.products
      ? data.resources.results.products
      : [];

    const exact = products.find(product =>
      String(product.title || '').trim().toLowerCase() === title.trim().toLowerCase()
    );

    return exact || products[0] || null;
  } catch (error) {
    console.warn('[Seven Heavens] Shopify product search failed for ' + title, error);
    return null;
  }
}

async function resolveBoxVariant(size) {
  if (boxVariantCache[size]) return boxVariantCache[size];

  // 1. Use the variant supplied by the Theme Editor if present.
  const linkedVariant = getBoxProductId(size);
  if (linkedVariant) {
    boxVariantCache[size] = String(linkedVariant);
    return String(linkedVariant);
  }

  // 2. Use the linked product handle if the Theme Editor has one.
  let product = await productFromHandle(getBoxProductHandle(size));

  // 3. If the Theme Editor settings were reset when the theme ZIP was uploaded,
  // discover the box product directly from Shopify by its exact product title.
  if (!product) {
    const found = await findProductByExactTitle(BOX_TITLES[size]);
    if (found && found.handle) {
      product = await productFromHandle(found.handle);
    }
  }

  if (!product) {
    console.error('[Seven Heavens] Could not find Shopify product "' + BOX_TITLES[size] + '".');
    return '';
  }

  // Prefer an available variant. Fall back to the first variant only if Shopify
  // reports none as available; cart/add.js will then return Shopify's exact reason.
  const variants = Array.isArray(product.variants) ? product.variants : [];
  const variant = variants.find(v => v.available) || variants[0];

  if (variant && variant.id) {
    boxVariantCache[size] = String(variant.id);
    return String(variant.id);
  }

  console.error('[Seven Heavens] Shopify product "' + BOX_TITLES[size] + '" has no variants.');
  return '';
}

function selectSize(size) {
  capacity = Number(size);
  FLAVOURS.forEach(f => counts[f] = 0);

  document.querySelectorAll('.sz-btn').forEach(button => {
    const active = Number(button.dataset.size) === capacity;
    button.classList.toggle('active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  });

  const note = document.getElementById('sh-note');
  if (note) note.textContent = '';

  update();
}

function inc(flavour) {
  if (!Object.prototype.hasOwnProperty.call(counts, flavour)) return;
  if (total() >= capacity) return;
  counts[flavour] += 1;
  update();
}

function dec(flavour) {
  if (!Object.prototype.hasOwnProperty.call(counts, flavour)) return;
  if (counts[flavour] <= 0) return;
  counts[flavour] -= 1;
  update();
}

function update() {
  FLAVOURS.forEach(flavour => {
    const value = document.getElementById('c-' + flavour);
    if (value) value.textContent = counts[flavour];

    const minus = document.querySelector('[data-qty-minus="' + flavour + '"]');
    const plus = document.querySelector('[data-qty-plus="' + flavour + '"]');

    if (minus) minus.disabled = counts[flavour] <= 0;
    if (plus) plus.disabled = total() >= capacity;
  });

  const selected = total();

  const bar = document.getElementById('sh-bar');
  if (bar) bar.style.width = Math.min(100, selected / capacity * 100) + '%';

  const count = document.getElementById('sh-count');
  if (count) count.textContent = selected + ' of ' + capacity + ' selected';

  const totalEl = document.getElementById('sh-total');
  if (totalEl) totalEl.textContent = '£' + PRICES[capacity];

  const summary = document.getElementById('sh-summary');
  if (summary) {
    summary.innerHTML = '';
    const chosen = FLAVOURS.filter(flavour => counts[flavour] > 0);

    if (!chosen.length) {
      const empty = document.createElement('li');
      empty.className = 'empty';
      empty.textContent = 'No cookies selected yet';
      summary.appendChild(empty);
    } else {
      chosen.forEach(flavour => {
        const item = document.createElement('li');
        const name = document.createElement('span');
        const quantity = document.createElement('span');
        name.textContent = NAMES[flavour];
        quantity.textContent = '×' + counts[flavour];
        item.appendChild(name);
        item.appendChild(quantity);
        summary.appendChild(item);
      });
    }
  }

  document.querySelectorAll('.flav').forEach(card =>
    card.classList.toggle('full', selected >= capacity)
  );

  const addButton = document.getElementById('sh-addbox');
  if (addButton) {
    if (selected === capacity) {
      // Do not falsely display "Box unavailable" while a product lookup is pending.
      addButton.disabled = false;
      addButton.textContent = 'Add Box to Bag · £' + PRICES[capacity];
    } else {
      addButton.disabled = true;
      addButton.textContent = 'Add ' + (capacity - selected) + ' more';
    }
  }
}

function wireBuildBoxQuantityControls() {
  document.querySelectorAll('[data-qty-plus]').forEach(button => {
    button.addEventListener('click', function () {
      inc(this.dataset.qtyPlus);
    });
  });

  document.querySelectorAll('[data-qty-minus]').forEach(button => {
    button.addEventListener('click', function () {
      dec(this.dataset.qtyMinus);
    });
  });

  document.querySelectorAll('.sz-btn').forEach(button => {
    button.setAttribute('aria-pressed', button.classList.contains('active') ? 'true' : 'false');
    button.addEventListener('click', function () {
      selectSize(this.dataset.size);
    });
  });

  update();
}

async function addBox() {
  const button = document.getElementById('sh-addbox');
  const note = document.getElementById('sh-note');

  if (!button || total() !== capacity) return;

  const originalText = button.textContent;
  button.disabled = true;
  button.classList.add('is-loading');
  button.textContent = 'Checking box…';
  if (note) note.textContent = '';

  try {
    const variantId = await resolveBoxVariant(capacity);

    if (!variantId) {
      throw new Error('We could not find the Shopify ' + BOX_TITLES[capacity] + ' product. Check that it exists and has a variant.');
    }

    // Keep a human-readable summary AND individual quantities on the Shopify
    // line item. This makes the exact box contents visible in the cart, Shopify
    // order admin, order confirmation and other line-item-property surfaces.
    const flavourSummary = FLAVOURS
      .filter(flavour => counts[flavour] > 0)
      .map(flavour => counts[flavour] + '× ' + NAMES[flavour])
      .join(', ');

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('properties[Box size]', 'Box of ' + capacity);
    formData.append('properties[Cookie selection]', flavourSummary);

    // Store every possible cookie explicitly, including zero quantities, so
    // every Box of 6, 12 or 24 purchase has a complete, auditable breakdown.
    FLAVOURS.forEach(flavour => {
      formData.append('properties[Cookie — ' + NAMES[flavour] + ']', String(counts[flavour]));
    });

    // Also store a compact machine-readable breakdown for integrations/apps.
    formData.append(
      'properties[Cookie quantities]',
      FLAVOURS.map(flavour => NAMES[flavour] + ': ' + counts[flavour]).join(' | ')
    );

    button.textContent = 'Adding Box…';

    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: formData
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || 'Shopify could not add this box to the basket.');
    }

    await response.json();

    button.classList.remove('is-loading');
    button.classList.add('is-added');
    button.textContent = 'Added to Bag ✓';

    if (note) note.textContent = 'Box of ' + capacity + ' added to your bag · ' + flavourSummary + '.';

    document.dispatchEvent(new CustomEvent('sevenheavens:cart-updated'));

    FLAVOURS.forEach(flavour => counts[flavour] = 0);
    update();

    setTimeout(() => {
      button.classList.remove('is-added');
      update();
    }, 1600);

  } catch (error) {
    console.error('[Seven Heavens] Build a Box error:', error);
    button.classList.remove('is-loading');
    button.classList.add('is-error');
    button.disabled = false;
    button.textContent = 'Try again';

    if (note) note.textContent = error.message;

    setTimeout(() => {
      button.classList.remove('is-error');
      update();
    }, 2200);
  }
}

document.addEventListener('DOMContentLoaded', wireBuildBoxQuantityControls);
